// ✅ Post-signup Setup Choice — pops for every NEW account (mint-style modal).
// "WhatsApp Agent Setup" (auto node-wire + tour) vs "Custom Agent" (builder).
// Until the user chooses, this modal is the first thing they see — on any tab,
// in either Simple or Complete mode. Dismissing = "Other" (never nags again).
import React, { useState, useEffect } from 'react';

function authHeaders(token?: string): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  const t = token || (typeof window !== 'undefined' ? localStorage.getItem('tenet_auth_token') : null);
  if (t) h['Authorization'] = t.startsWith('Bearer ') ? t : `Bearer ${t}`;
  return h;
}

export default function SetupChoiceModal({ token, onChoose }: { token?: string; onChoose: (choice: 'whatsapp_agent' | 'other', whatsappNumber?: string) => void }) {
  const [waNumber, setWaNumber] = useState('');
  const [busy, setBusy] = useState(false);

  const choose = async (choice: 'whatsapp_agent' | 'other') => {
    if (busy) return;
    setBusy(true);
    try {
      await fetch('/api/tenet/onboarding/setup-choice', {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify({ choice, whatsappNumber: waNumber.trim() }),
      });
    } catch { /* the choice is remembered server-side on success only */ }
    setBusy(false);
    onChoose(choice, waNumber.trim());
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18, background: 'rgba(2, 8, 20, 0.72)', backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)' }}>
      <div className="liquid-card-3d" style={{ width: '100%', maxWidth: 380, padding: '22px 18px' }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <div style={{ fontSize: 34 }}>🌙</div>
          <div style={{ fontWeight: 900, fontSize: 18, color: '#E6F4FF', marginTop: 6 }}>Luna ට සාදරයෙන් පිළිගන්නවා!</div>
          <div style={{ fontSize: 12.5, color: '#A9C7E8', marginTop: 4 }}>මොන වගේ agent එකක්ද setup කරන්න ඕන?</div>
        </div>

        <button
          onClick={() => choose('whatsapp_agent')}
          disabled={busy}
          className="liquid-card-3d"
          style={{ width: '100%', textAlign: 'left', padding: 14, marginBottom: 10, cursor: 'pointer', borderColor: 'rgba(52,211,153,0.5)', display: 'flex', alignItems: 'center', gap: 12 }}
        >
          <div style={{ fontSize: 22, width: 42, height: 42, borderRadius: 13, background: 'rgba(16,185,129,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>📱</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 14, color: '#ECFDF5' }}>WhatsApp Agent Setup</div>
            <div style={{ fontSize: 11.5, color: '#94a3b8' }}>nodes auto-wire · tour එක · WhatsApp අන්තිමට</div>
          </div>
          <div style={{ color: '#34d399', fontSize: 16 }}>→</div>
        </button>

        <button
          onClick={() => choose('other')}
          disabled={busy}
          className="liquid-card-3d"
          style={{ width: '100%', textAlign: 'left', padding: 14, marginBottom: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12 }}
        >
          <div style={{ fontSize: 22, width: 42, height: 42, borderRadius: 13, background: 'rgba(125,211,252,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>🛠️</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 800, fontSize: 14, color: '#E6F4FF' }}>Custom Agent — builder</div>
            <div style={{ fontSize: 11.5, color: '#94a3b8' }}>මා node builder එකෙන් setup කරන්නම්</div>
          </div>
          <div style={{ color: '#7dd3fc', fontSize: 16 }}>→</div>
        </button>

        {busy && <div style={{ textAlign: 'center', color: '#34d399', fontSize: 12 }}>setting up…</div>}
      </div>
    </div>
  );
}
